const config = {
  env: "local",
  apiUrl: "https://api.nextastroapi.com/api/",    // main
  //  apiUrl: "https://nicky-unconcordant-otiosely.ngrok-free.dev/api/"
  // apiUrl: "https://api.nextastroapi.com/api/"    // test domain
  // apiUrl: "http://192.168.0.61:5800/api/"      // local aditi
};

export default config;